import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

type Props = {
  center?: boolean;
  marginTop?: number;
  size: number;
};

/**
 * @deprecated in favor of LoadingSpinner
 */
const Spinner: React.FC<Props> = ({ size, center, marginTop }) => (
  <div style={{ margin: center ? "0 auto" : 0, marginTop: marginTop || 0, padding: "11px 0px 0px 12px" }}>
    <CircularProgress 
      size={size}
      style={{
        color: "#B6B6B6",
      }}
    />
  </div>
);

export default Spinner;
